/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SysqueOptionLineVM } from '../../models/sysque-option-line-vm';

@Component({
  selector: 'sysque-options-line',
  templateUrl: './sysque-options-line.component.html',
  styleUrls: ['./sysque-options-line.component.scss'],
  standalone: false
})
export class SysqueOptionsLineComponent {
  expandedItem: SysqueOptionLineVM = null;
  @Input() sysqueOption: SysqueOptionLineVM[];
  @Output() expanded: boolean;
  @Output() enabled: boolean;
  @Output() itemToggled = new EventEmitter<SysqueOptionLineVM>();
  @Output() switchClicked = new EventEmitter<SysqueOptionLineVM>();
  items: SysqueOptionLineVM[] = [];

  public ngOnInit(): void {
    for (let value of this.sysqueOption) {
      this.items.push({ title: value.title, content: value.content, expanded: value.expanded, enabled: value.enabled });
    }
  }

  public toggleItem(item: SysqueOptionLineVM): void {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i] === item) {
        continue;
      }

      this.items[i].expanded = false;
    }

    if (this.expandedItem) {
      this.expandedItem.expanded = false;
    }

    if (this.expandedItem === item) {
      this.expandedItem = null;
    } else {
      item.expanded = true;
      this.expandedItem = item;
    }

    this.itemToggled.emit(item);
  }

  public onSwitchClick(item: SysqueOptionLineVM): void {
    this.switchClicked.emit(item);
  }
}
